// src/utils.js

// Utility function to remove Vietnamese diacritics
export const removeDiacritics = (str) => {
    return str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/đ/g, 'd')
      .replace(/Đ/g, 'D');
  };
  
  // Utility function to generate initials
  export const getInitials = (fullName) => {
    const words = fullName.trim().split(/\s+/);
    return words.map(word => removeDiacritics(word[0])).join('').toUpperCase();
  };
  
  // Generate student ID based on holy name, full name, and student count
  export const generateStudentId = (holyName, fullName, studentCount) => {
    const holyNameInitial = holyName ? removeDiacritics(holyName[0]).toUpperCase() : '';
    const fullNameInitials = getInitials(fullName);
    const countPadded = String(studentCount + 1).padStart(3, '0'); // VD: 001, 002
  
    return `${countPadded}${holyNameInitial}${fullNameInitials}`;
  };